import { gql } from 'apollo-boost'

export const GetCurrencyExchangeRate = gql`
  query getCurrencyExchangeRate($input: CurrencyExchangeRateInput!) {
    getCurrencyExchangeRate(input: $input) {
      amount
    }
  }
`
